import React, { useState, useEffect, useContext} from "react";
import axios from "axios";
import { parseText } from "../../Helpers/parse";
import Preview from "../Preview";
import { GlobalContext } from "../../Context/GlobalContext";
import { validateExpirationDate } from "../../utils/handlePremiereDates";

const RecommendedVideosList = ({ 
  url, 
  user, 
  videoId, 
  type, 
  setFile, 
  color,
  recommendationList, 
}) => {

  const [recommendedVideos, setRecommendedVideos] = useState(recommendationList);
  const [updated, setUpdated] = useState(false);
  const {darkMode} = useContext(GlobalContext)
  useEffect(() => {
    (async () => {

      if (recommendedVideos.length === 0 && !updated) {
        setUpdated(true);
        const { data } = await axios.post(`${url}/upload/search`, {
          _id: user,
          search: "",
          limit: 15,
        })
        setRecommendedVideos(data.response.payload.files)
      }
    })()
  },[user]);


    // if (this.props.finished) {
    //   this.props.togglePlayNext(false);
    //   setTimeout(() => {
    //     this.props.togglePlayNext(true);
    //     if (this.props.type === "playlist")
    //       this.props.setFile(
    //         this.state.recomended[0],
    //         this.state.recomended,
    //         "playlist"
    //       );
    //     else this.props.setFile(this.state.recomended[0], [], "");
    //   }, 5000);
    // }
  

    const videos = recommendedVideos.map(file => {
      if (
        file.access !== "open" 
        || file._id === videoId 
        || validateExpirationDate(file?.premiereDate)
      ) return null;

      return (
        <div 
          key={file._id}
          className='video-'
          onClick={() => {
            if (type === "playlist") {
              return setFile(file, recommendedVideos, "playlist");
            }
            setFile(file, [], "");
          }}
          style={{ marginBottom: '12px' }}
        >
          <div className="flex-row">
            <div className="flex-1">
              <Preview
                url={url}
                file={file._id}
                color={color}
              />
            </div>
            <div className="flex-1 recomended">
              <p className="truncate-overflow">{file.metadata.filename}</p>
              <p className={darkMode?"dark dt bold":"dt bold"}>
                {parseText(
                  file.switches.date.selected === "original date"
                    ? new Date(file.original_date)
                    : new Date(file.date)
                )}
              </p>
            </div>
          </div>
        </div>
      );
      
    });

    return (
      <div style={{ height: "100%" }}>
        {/* <div id="up-next-txt">Up Next</div> */}
        <ul className="list-group">{videos}</ul>
      </div>
    );
  
}
export default RecommendedVideosList;
